const YANDEX_COUNTER_ID = 95416800
const GOOGLE_COUNTER_ID = 'G-50Y1BBEJ3R'

function createYandexCounter () {
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.innerHTML = `(function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
   m[i].l=1*new Date();
   for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
   k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
   (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
   ym(${YANDEX_COUNTER_ID}, "init", {
        clickmap:true,
        trackLinks:true,
        accurateTrackBounce:true,
        webvisor:true,
        trackHash:true
   });

`

  const noscript = document.createElement('noscript')
  const div = document.createElement('div')
  div.innerHTML = `<img src="https://mc.yandex.ru/watch/${YANDEX_COUNTER_ID}" style="position:absolute; left:-9999px;" alt=""/>`
  noscript.appendChild(div)
  document.body.appendChild(script)
  document.body.appendChild(noscript)
}

function createGoogleCounter () {
  const asyncScript = document.createElement('script')
  asyncScript.type = 'text/javascript'
  asyncScript.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_COUNTER_ID}`
  asyncScript.async = true

  const script = document.createElement('script')
  script.innerHTML = `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());gtag('config', '${GOOGLE_COUNTER_ID}');`
  document.body.appendChild(asyncScript)
  document.body.appendChild(script)
}

function sendGoal (eventName) {
  try {
    window.ym(YANDEX_COUNTER_ID, 'reachGoal', eventName)
  } catch (err) {
    console.error(err)
  }
  try {
    window.gtag('event', eventName)
  } catch (err) {
    console.error(err)
  }
}

export default class Metric {
  constructor () {
    createYandexCounter()
    createGoogleCounter()
  }

  openRegistrationForm () {
    sendGoal('open_registration_form')
  }

  registration () {
    sendGoal('registration')
  }

  createInspection () {
    sendGoal('inspection_create')
  }

  acceptInspection () {
    sendGoal('inspection_accept')
  }

  refuseInspection () {
    sendGoal('inspection_refuse')
  }
  inspectionShareEnable() {
    sendGoal('inspection_share_enable')
  }

  inspectionShareLinkClick() {
    sendGoal('inspection_share_link_click')
  }

  inspectionSendActToDeveloper() {
    sendGoal('inspection_send_act_to_developer')
  }
}
